import { QueryOptions } from "../components/Common/useQuery";
import useUserQuery from "../components/Common/useUserQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

export interface TransportSyncStatusDto {
  complete: boolean;
  error: string | null;
}

const useGetTransportSyncStatus = (siteId: string, notificationId: string, options?: QueryOptions<TransportSyncStatusDto>) => {
  const business = useSelectedBusiness();
  return useUserQuery<TransportSyncStatusDto>({
    path: `/api/businesses/${business.id}/transports/sync/status?siteId=${siteId}&notificationId=${notificationId}`,
  }, options);
}

export default useGetTransportSyncStatus;
